import {
  DESIGNER_IMPORT_CSV_IRI,
  DESIGNER_IMPORT_FILENAME_IRI,
  RDFS_LABEL_IRI,
  SCHEMA_ORG_DATE_PUBLISHED_IRI,
  SYSTEM_VOICEBOX_INSTRUCTIONS_IRI,
  XSD_DATE_TIME_IRI,
} from 'src/templates/queries/iris';
import { escapeDoubleQuotes } from 'src/utils/escapeDoubleQuotes';

// Turtle double-quoted strings cannot contain literal newlines (unlike triple-quoted strings).
const escapeForTurtleString = (text: string) =>
  escapeDoubleQuotes(text).replace(/\n/g, '\\n').replace(/\r/g, '\\r');

export const stringifyProjectMetadata = ({
  namedGraph,
  label,
  publishedDate,
  filename,
  voiceboxInstructions,
}: {
  namedGraph: string;
  label: string;
  publishedDate: number;
  filename?: string;
  voiceboxInstructions?: string;
}) => {
  const isoDate = new Date(publishedDate).toISOString();
  return `\
<${namedGraph}> {
  <${namedGraph}> ${
    filename
      ? `
    a <${DESIGNER_IMPORT_CSV_IRI}> ;
    <${DESIGNER_IMPORT_FILENAME_IRI}> "${escapeForTurtleString(filename)}" ;`
      : ''
  }${
    voiceboxInstructions
      ? `
    <${SYSTEM_VOICEBOX_INSTRUCTIONS_IRI}> "${escapeForTurtleString(
          voiceboxInstructions
        )}" ;`
      : ''
  }
    <${RDFS_LABEL_IRI}> "${escapeForTurtleString(label)}" ;
    <${SCHEMA_ORG_DATE_PUBLISHED_IRI}> "${isoDate}"^^<${XSD_DATE_TIME_IRI}> .
}`;
};
